import { useEffect, useState } from "react";
import { Hammer } from "lucide-react";

/**
 * EssenceBurst (iter67) — floating "+N ESSENCE" toast rendered on death.
 * Shows anvil icon + rising/fading number so the drop registers emotionally.
 * Fire-once per `amount` key change; auto-unmounts after animation.
 */
export default function EssenceBurst({ amount = 0 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!amount || amount <= 0) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2600);
    return () => clearTimeout(t);
  }, [amount]);

  if (!visible || amount <= 0) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[95] flex items-start justify-center pt-24"
      aria-hidden="true"
      data-testid="essence-burst"
    >
      <div
        className="essence-burst flex items-center gap-3 px-6 py-3 rounded-sm"
        style={{
          background: "linear-gradient(135deg, rgba(10,5,3,0.98), rgba(40,25,10,0.95))",
          boxShadow: "0 0 36px rgba(212,175,55,0.55), inset 0 0 20px rgba(212,175,55,0.15)",
          border: "1px solid rgba(212,175,55,0.7)",
        }}
      >
        <Hammer size={22} className="gold-text" />
        <div className="font-heading text-2xl gold-text italic">+{amount}</div>
        <div className="text-[10px] tracking-[0.45em] ash-text">ESSENCE</div>
      </div>
    </div>
  );
}
